module.exports = __webpack_public_path__ + "static/spotify_white-24eaba4336065d0f3232725e02d0a42d.png";